import z from "zod";

import { CodeIconSchema } from "./common.schema";
import { StrapiMediaSchema } from "./media.schema";

/* --- Route --- */
export const RouteSchema = z.object({
  id: z.number(),
  title: z.string(),
  route: z.string(),
  isComingSoon: z.boolean().optional(),
  media: StrapiMediaSchema.nullable().optional(),
  mediaMobile: StrapiMediaSchema.nullable().optional(),
});

/* --- Social Link --- */
export const SocialLinkCollectionSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().optional(),
  name: z.string(),
  url: z.string(),
  label: z.string(),
  icon: CodeIconSchema,
  createdAt: z.string().datetime().optional(),
  updatedAt: z.string().datetime().optional(),
  publishedAt: z.string().datetime().optional(),
});

/* --- Menu --- */
export const CategorySchema = z.object({
  id: z.number(),
  title: z.string(),
  routes: z.array(RouteSchema),
});

export const MenuSchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
  categories: z.array(CategorySchema),
});
